import { observer } from "mobx-react";
import moment from "moment";
import { useEffect } from "react"; // React hooks
import { Modal } from "react-bootstrap"; // Bootstrap modal and tabs
import { FormattedMessage } from "react-intl";
import { formatMinutesToHours, getOptionNameFromServiceName } from "../../../../constants/constants";
import { useStore } from "../../../../contexts/store-provider"; // custom store context
import { IOption } from "../../../../models/ICommon"; // option interface
import FormLoader from "../../../../shared-components/FormLoader/FormLoader";
import { serviceTypeEnum } from "../../../../constants/enums/service-type-enum";
interface IProps {
  onModalClosed: () => void;
  title: string; // modal title
  selectedStaff: number; // selected staff option
  storeIdSearch: number; // store ID for search
  allStaffs: IOption[]; // list of all staff options
  isLoading?: boolean; // loading state
}

const ShowAllReservationsPopup = (props: IProps) => {
  // close modal handler
  const onModalClosed = () => {
    props.onModalClosed();
  };

  // store context
  const { reservationSchedulerStore } = useStore();
  const {
    GetStaffAppointmentsListForDateService,
    getStaffAppointmentsDate, // Get staff appointments by date
  } = reservationSchedulerStore;

  useEffect(() => {
    GetStaffAppointmentsListForDateService(
      props.selectedStaff,
      props.storeIdSearch,
      moment(props.title).format("YYYY-MM-DD"),
      moment(props.title).format("YYYY-MM-DD")
    );
  }, []);

  return (
    <>
      <Modal show={true} centered size="lg">
        {/* modal header */}
        <Modal.Header>
          <Modal.Title>
            {/* modal title */}
            {props.title}
            <button onClick={onModalClosed} className="Crossicons">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="23"
                fill="currentColor"
                className="bi bi-x"
                viewBox="0 0 16 16"
              >
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </button>
          </Modal.Title>
          {/* tabs for break type */}
        </Modal.Header>
        {/* break details form */}
        <Modal.Body>
          {props.isLoading && <FormLoader loading={props.isLoading} />}
          <table className="table table-bordered">
            <thead>
              <tr>
                {/* <th className="col-md-2">
                  <FormattedMessage id="date_time" />
                </th> */}
                <th className="col-md-3">
                  <FormattedMessage id="staff" />
                </th>
                <th className="col-md-5">
                  <FormattedMessage id="treatment_name" />
                </th>
                <th className="col-md-4 text-end">
                  <FormattedMessage id="total_time" />
                </th>
              </tr>
            </thead>
            <tbody>
              {getStaffAppointmentsDate?.map(
                (appointment: any, index: number) => (
                  <tr key={index}>
                    <td className="col-md-3">
                      <div className="d-flex align-items-center">
                        <div className="">
                          <h3 className="">
                            {
                              props.allStaffs.find(
                                (staff) => staff.id === appointment.StaffId
                              )?.data.StaffName
                            }
                          </h3>
                          <h4 className="fw-normal text-muted">
                            {moment(
                              `${moment(appointment.Date).format(
                                "YYYY-MM-DD"
                              )} ${appointment.Time}`,
                              "YYYY-MM-DD HH:mm:ss"
                            ).format("YYYY-MM-DD HH:mm")}
                          </h4>
                        </div>
                      </div>
                    </td>
                    <td className="col-md-5">
                      <h4 className="fw-normal text-muted text-wrap">
                        {appointment?.ServiceRequestedList?.length > 0
                          ? appointment.ServiceRequestedList.map(
                              (service: any, idx: number) => {
                                let serviceName =
                                  service.ServiceType === serviceTypeEnum.Option
                                    ? getOptionNameFromServiceName(service?.ServiceName)
                                    : service?.ServiceName;
                                return (
                                <span key={idx}>
                                  {serviceName}
                                  {idx <
                                  appointment.ServiceRequestedList.length - 1
                                    ? ", "
                                    : ""}
                                </span>
                              )}
                            )
                          : "No services requested"}
                        {/* <ServiceNameDisplayComponent
                          services={appointment?.ServiceRequestedList} // List of requested services
                        /> */}
                      </h4>
                    </td>
                    <td className="col-md-4 text-end">
                      <h4 className="fw-normal text-muted">
                        {formatMinutesToHours(appointment.TotalTime)}
                      </h4>
                    </td>
                  </tr>
                )
              )}
            </tbody>
            {/* {JSON.stringify(getStaffAppointmentsDate)} */}
          </table>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default observer(ShowAllReservationsPopup);
